import "./hrbrain.css";

function HRbrain() {
    return <hr />
}

export default HRbrain;